import { render, staticRenderFns } from "./OrderDocumentationRepairExtension.vue?vue&type=template&id=15d019aa&scoped=true"
import script from "./OrderDocumentationRepairExtension.vue?vue&type=script&lang=js"
export * from "./OrderDocumentationRepairExtension.vue?vue&type=script&lang=js"
import style0 from "./OrderDocumentationRepairExtension.vue?vue&type=style&index=0&id=15d019aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d019aa",
  null
  
)

export default component.exports